import { z } from "zod";

import { pipelineActionTypeSchema } from "./enums";
import { ruleActionConfigurationSchema } from "./rule-action-configuration";

export const pipelineActionSchema = z.object({
	id: z.string(),
	type: pipelineActionTypeSchema,
	configuration: ruleActionConfigurationSchema.optional(),
});
export type PipelineAction = z.infer<typeof pipelineActionSchema>;
